import { useNavigate } from "react-router-dom";
import ButtonWithIcon from "src/components/UI/ButtonWithIcon/ButtonWithIcon";
import { useLocaleContext } from "src/context/locale-context";
import classes from "./SearchTypeItemGroup.module.css";

function SearchTypeButton({ item, isActive, onSelect }) {
  return (
    <li className={isActive ? classes.selected : ""}>
      <ButtonWithIcon
        imgHeight={16}
        name={item.type}
        imgEl={item.icon}
        onClick={() => onSelect(item.type)}>
        {item.title}
      </ButtonWithIcon>
    </li>
  );
}

function SearchTypeItemGroup({ activeType = "flights" }) {
  const { getStringRes } = useLocaleContext();
  const navigate = useNavigate();
  const isCharterEnabled = window.SERVER_DATA?.REACT_APP_ENABLE_CHARTER_IFRAME === "true";

  const searchTypeItems = [
    {
      icon: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M21 16V14L13 9V3.5C13 2.67 12.33 2 11.5 2C10.67 2 10 2.67 10 3.5V9L2 14V16L10 13.5V19L8 20.5V22L11.5 21L15 22V20.5L13 19V13.5L21 16Z" fill="currentColor"/>
        </svg>
      ),
      type: "flights",
      title: getStringRes("main.nav.airtickets"),
      path: "/",
    },
    {
      icon: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17.553 16.75a7.5 7.5 0 0 0 -10.606 0" />
          <path d="M18 3.804a6 6 0 0 0 -8.196 2.196l10.392 6a6 6 0 0 0 -2.196 -8.196" />
          <path d="M16.732 10c1.658 -2.87 2.225 -5.644 1.268 -6.196c-.957 -.552 -3.075 1.326 -4.732 4.196" />
          <path d="M15 9l-3 5.196" />
          <path d="M3 19.25a2.4 2.4 0 0 1 1 -.25a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 1 .25" />
        </svg>
      ),
      type: "charters",
      title: getStringRes("main.nav.charters"),
      path: "/charter-flights",
    },
  ];

  const onSelectSearchType = (type) => {
    const item = searchTypeItems.find(i => i.type === type);
    if (item && type !== activeType) {
      navigate(item.path);
    }
  };

  if (!isCharterEnabled) {
    return null;
  }

  return (
    <ul className={`${classes.container} ${classes.searchTypes}`}>
      {searchTypeItems.map((item) => (
        <SearchTypeButton
          key={item.type}
          item={item}
          isActive={item.type === activeType}
          onSelect={onSelectSearchType}
        />
      ))}
    </ul>
  );
}


export default SearchTypeItemGroup;
